<!-----------------------------------------------------------------------------
  - Copyright (c) 2018. keni <$email>                                         -
  -                                                                           -
  - This file CalendarList.vue is part of event_pass_client.dev.              -
  - Unauthorized copying of this file, via any medium is strictly prohibited. -
  - Proprietary and confidential                                              -
  - CalendarList.vue can not be copied and/or distributed                     -
  - without the express permission of keni                                    -
  ----------------------------------------------------------------------------->

<!--//Created by keni.--><!--//User: keni--><!--//Date: 13/03/2018--><!--//Time: 09:35-->

<template>
    <section style="height:700px; overflow: scroll;">

        <!--show the title if we have one set-->
        <div v-if="typeof use_title_slot !== 'undefined' && use_title_slot !== null"
                class="d-flex justify-content-between align-items-center"
        >
            <slot name="title" class="wrap"></slot>
            <div class="d-flex justify-content-between align-items-center">
                <div v-show="expanded === true">
                    <list-provided-search
                            v-show="expanded === true"
                            @search_="inputSearching"
                            @search_active_="searchActive"
                            expanded_class="w-100-0 bg-white"
                    />
                </div>

                <!--accordion arrows-->
                <i
                        v-if="expanded"
                        v-on:click="toggleAccordion"
                        class="material-icons cursor-pointer"
                >keyboard_arrow_down</i>
                <i
                        v-else
                        v-on:click="toggleAccordion"
                        class="material-icons cursor-pointer"
                >keyboard_arrow_up</i>
            </div>
        </div>
        <!--another kind of title???-->
        <div v-else>
            <div v-if="typeof title !== 'undefined' && title !== null">
                <h3 v-if="title.html && filter_list"
                        class="d-flex justify-content-between align-items-center"
                >
                    <span v-html="title.html" :class="title.cls"></span>
                    <span class="d-flex justify-content-between align-items-center">
                        <span v-show="expanded === true">
                            <list-provided-search
                                    v-show="expanded === true"
                                    @search_="inputSearching"
                            />
                </span>

                        <!--accordion arrows-->
                        <i
                                v-if="expanded"
                                v-on:click="expanded = !expanded"
                                class="material-icons"
                        >keyboard_arrow_down</i>
                        <i
                                v-else
                                v-on:click="expanded = !expanded"
                                class="material-icons"
                        >keyboard_arrow_up</i>
                    </span>
                </h3>
            </div>
        </div>

        <!--the content-->
        <transition name="fade">
            <div v-if="expanded === true">
                <!--hide if no results-->
                <div v-if="entries.length <= 0">
                    <div v-if="settings.show_on_null"
                            class="text-muted"
                            :class="list_classes"
                    >{{msg.no_events}}
                    </div>
                </div>
                <nav data-ref="list_style--row" v-if="list_style === 'row'">
                    <div v-for="item in entries"
                            class=" waves-effect"
                    >
                        <!--show active link clicks-->
                        <a v-if="layout.actions.active_click"
                                :href="createLink(item)"
                        >
                            <h3 class="h5 pl-0">{{readTitle(item)}}</h3>
                            <p>
                                <span class="fa fa-calendar"></span> {{getDate(item.start_date)}}
                                <span class="fa fa-clock-o"></span> {{getTime(item.start_date)}} </p>
                        </a>
                        <div v-else="">
                            <h1>{{readTitle(item)}}</h1>
                            <h3 class="h5 pl-0">{{item[path.data].lang.en_GB.title}}</h3>
                            <p>
                                <span class="fa fa-calendar"></span> {{getDate(item.start_date)}}
                                <span class="fa fa-clock-o"></span> {{getTime(item.start_date)}} </p>
                        </div>
                    </div>
                </nav>
                <nav data-ref="list_style--calendar-list" v-else
                        class="calendar calendar-list"
                >
                    <ul data-element-type="event-list"
                            class="list-group"
                    >
                        <template v-for="(item,index) in entries.slice(0,max_results)"
                                :data-add-pt="index"
                        >
                            <li :data-month-counter="index"
                                    class="list-group-item border-0 px-0 pb-0 pb-md-2 pt-0 pt-md-2"
                            >
                                <!--{{list_entry_limit = list_entry_limit + 1}}-->
                                <!--<h3>hi! {{log(items,index)}}</h3>-->
                                <event-list
                                        class="hover-show-watch pl-0 pl-md-2"
                                        :data-ticket-counter="index"
                                        location_link="false"
                                        :item="item"
                                        :path="path"
                                        :base_url="base_url"
                                />
                            </li>
                        </template>
                    </ul>
                </nav>
            </div>
        </transition>
    </section>
</template>

<script>
    import {_} from 'underscore';
	import {
		getDate,
		getTime,
		setDate,
		getYear,
		getMonth,
		getDay
	} from '../../../../../app/Shared/Resources/Assets/js/helpers/format.date';
	import startOfMonth from 'date-fns/start_of_month';

	export default {
		name: "calendar-list",
		components: {},
		props: [
			'use_title_slot',
			'title', //Object title.html,title.text,title.cls
			'filter_list', // will listen to a search method
			'list_limit',
			'items',
			'layout',
			'path',
			'msg',
			'params',
			'list_classes',
			'base_url',
			'list_style',
			'request_url',
			'request_url_params',
            'set_max_results'
		],
		watch: {
			/**
			 * Update the list when items change
			 * */
			items(items) {
				this.entries = _.clone(items);
				this.backup = _.clone(items);
				this.compileEntries();

				// console.log('items', 'items', items);

			},
			layout(item) {
				// console.log('layout', item);
			},
			path(item) {
				// console.log('path', item);
			},
			msg(item) {
				// console.log('msg', item);
			},
			list_classes(item) {
				// console.log('list_classes', item);
			},
			base_url(item) {
				// console.log('base_url', item);
			}
		},
		created() {

		},
		destroyed() {
		},
		mounted() {
// this.$nextTick(function () {
// 			console.log('this.items', this.items);
// })
			if (typeof this.list_limit !== 'undefined' && this.list_limit !== null) {
				this.set_list_limit = this.list_limit;
			}
			if (typeof this.set_max_results !== 'undefined' && this.set_max_results !== null) {
				this.max_results = this.set_max_results;
			}
			if (typeof this.items !== 'undefined' && this.items !== null) {
				// console.log('mounted', 'this.items',this.items);
				if (!_.isEmpty(this.items)) {
					this.entries = this.items;
                    // Vue.$set('entries',this.items);
					this.backup = _.clone(this.entries);
					this.compileEntries();
				}

			}
			else {
				if (typeof this.request_url !== 'undefined' && this.request_url !== null) {
					this.readData();
				}
			}

			// console.log('this.entries', this.entries);
		},
		data() {
			return {
				show_groups: false,
				list_entry_limit: 0,
				max_results: 99,
				expanded: true,
				search_filter_item: '',
				is_search_active: false,
				months: {},
				settings: {
					show_first_month: true,
					show_on_null: true
				},
				set_list_limit: 1000,
				entries: [],
				backup: [],
				use_search: true,
			}
		},
		methods: {
			incrementTicket() {
				this.list_entry_limit = ++this.list_entry_limit;
				return this.list_entry_limit;
			},
			showEvent() {
				this.list_entry_limit = ++this.list_entry_limit;
				return true;
			},
			toggleAccordion() {
				// console.log('toggleAccordion', 'this.is_search_active',this.is_search_active);
				if (this.is_search_active !== true) {
					this.expanded = !this.expanded;
				}
			},
			searchActive(active) {
				// console.log('searchActive', 'active',active);
				this.is_search_active = active;
			},
			inputSearching(e) {
				// this.search_filter_item = e;
				// console.log('inputSearching', 'e',e);
				// if (typeof e !== 'undefined' && e !== null) {
				// 	// console.log('inputSearching', 'e',e);
				// 	this.entries = this.processEntries(e);
				// }
				// else {
				// 	this.entries = this.processEntries();
				// }
				// console.log('inputSearching', 'this.entries',this.entries);
				// this.entries = this.processEntries(e);
				this.entries = this.processEntries(e);
			},
			compileEntries() {
				// this.entries = this.processEntries();

				// this.entries = this.entries;
				// if (typeof this.list_style !== 'undefined' && this.list_style !== null) {
				//
				// }
				// else {
				// 	this.entries = this.processEntries();
				// }
				// console.log('compileEntries', 'this.entries', this.entries);
			},
			log(...args) {
				console.log(...args);
			},
			isActive(item) {
				// console.log('isActive', typeof item, 'item', item);
				return;
			},
			setFirstMonthActive(month, index) {
				let self = this;
				if (index > -1 && index < 1) {
					if (typeof self.months !== 'undefined' && self.months !== null) {
						// console.log('processEntries', 'setting object for first time');
						// this.$set(this.months[index], 'active', true);
						if (!self.months.hasOwnProperty(month)) {

							self.$set(self.months, month, {
								active: true
							});
							// console.log('processEntries', 'this.months',_this.months);
						}
						else {
							// console.log('processEntries', 'object defined',month,self.months);
							self.$set(self.months[month], 'active', true);
						}
					}

				}
				// console.log('setFirstMonthActive',month, 'this.months[month].active',this.months[month].active);
				return this.months[month].active;
			},
			viewMonthList(month) {
				let self = this;

				self.$set(this.months[month], 'active', (self.months[month].active != true));
				//
				// // this.months[index].active != this.months[index].active;
				// if (this.months[index].active == true) {
				// 	this.$set(this.months[index], 'active', false);
				// }
				// else {
				// 	this.$set(this.months[index], 'active', true);
				// }
			},
			/**
			 * creates a list grouped by dateTag
			 *
			 */
			processEntries(searchString) {
				let _this = this,
					search_filter = searchString;

				_this.entries = _.clone(this.backup);

				let search_array = _this.entries;

				if ((typeof search_filter !== 'undefined' && search_filter !== null) && search_filter !== '') {

					search_filter = search_filter.trim().toLowerCase();

					search_array = search_array.filter(function (item) {
						// return item;
						if (item.slug.toLowerCase().indexOf(searchString) !== -1) {
							return item;
						}
					});
				}
				// console.log('processEntries', 'search_array.slice(0,3)', search_array.slice(0, 3));
				return search_array;
				// return _.groupBy(_this.entries, function (item) {
				// 	let monthDateObj = setDate(item.start_date),
				// 		monthStartDateObj = startOfMonth(monthDateObj);
				//
				// 	// filter if there is a search present
				// 	if ((typeof search_filter !== 'undefined' && search_filter !== null) && search_filter != '') {
				// 		search_filter = search_filter.trim().toLowerCase();
				//
				// 		let filterPositionSlug = item.slug.indexOf(search_filter),
				// 			dateSet = _this.getDate(item.start_date, 'url_date').toLowerCase(),
				// 			// yearSet = _this.getDateString(item.start_date,'year_long').toLowerCase(),
				// 			filterPositionDate = dateSet.indexOf(search_filter);
				// 		// console.log('', 'yearSet', yearSet,'search_filter',search_filter);
				// 		// console.log('processEntries', search_filter, dateSet);
				// 		// console.log('processEntries',
				// 		// 	'filterPositionSlug', filterPositionSlug,
				// 		// 	'filterPositionDate', filterPositionDate
				// 		// )
				// 		// ;
				// 		if (
				// 			filterPositionSlug !== -1
				// 			|| filterPositionDate !== -1
				// 		// || yearSet !== -1
				// 		) {
				// 			// console.log('item.slug', item.slug,monthStartDateObj);
				// 			return getMonth(monthStartDateObj, 'name_short');
				// 		}
				// 	}
				// 	else {
				// 		return getMonth(monthStartDateObj, 'name_short');
				// 	}
				// });
			},
			readData() {
				let _this = this;
				let data = (typeof this.request_url_params !== 'undefined' && this.request_url_params !== null) ? JSON.parse(this.request_url_params) : {};
// console.log('data',data);

				// console.log('readData', 'requesting',data);

				axios.post(this.request_url, data)
					.then(function (response) {
						if (response.data.success) {
// console.log('response.data.result',response.data.result);
							_this.entries = response.data.result;
							_this.backup = _.clone(this.entries);
							// _this.compileEntries();
						}
					})
					.catch(function () {

					});
			},
			readTitle(item) {
				return item[this.path.data].lang.en_GB.title;
			},
			readDescription(item) {
				return item[this.path.data].lang.en_GB.description;
			},
			/**
			 *
			 * creates link provided from the route
			 * @param item
			 */
			createLink(item) {
				// console.log('item', item);
				// console.log('this.base_url', this.base_url);
				// console.log('createLink(item) this.path.route', this.path.route);
				let structure = this.path.route.structure.split('.');

				let routeUrl = this.path.route.name.split('/');
				routeUrl.shift();

				// console.log(this.path.route.structure, 'structure', structure);
				// console.log(this.path.route.name, 'routeUrl', routeUrl);

				for (let i = 0; i < structure.length; i++) {
					let route_element = structure[i];

					if (route_element + '_expr' === routeUrl[i]) {
						routeUrl[i] = route_element + '--added';

						switch (route_element) {
							case 'date':
								routeUrl[i] = this.getDate(item.start_date, 'url_date');
								break;

							case 'slug':
								routeUrl[i] = item.slug;
								break;
						}
					}

				}

				// console.log('routeUrl', routeUrl);
				return this.base_url + '/' + routeUrl.join('/').toLowerCase();
				// return createUrlFromData(table_data, this.path.route);

			},
			getDay(date) {
				//D
			},
			getMonth(date) {
				//MMM
			},
			getDateString(date, type) {
				if (type === 'year') {
					return getYear(date, false);
				}
				if (type === 'year_long') {
					return getYear(date, true);
				}
				else if (type === 'month') {
					return getMonth(date, 'name_short');
				}
				else if (type === 'day') {
					return getDay(date, 'num_short');
				}
				else {
					console.error('no date defined', date);
				}
				//YY

			},
			getDate(string, format) {
				// console.log(string, format);
				return getDate(string, format);
			},
			getTime(string) {
				return getTime(string);
			}
		},
		computed: {}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/lists/CalendarList.vue